<template>
  <NamiModal v-model="open">
    <NamiModalTitle @close="open = false">Share this List</NamiModalTitle>
    <div>
      <NamiSticker name="happy" class="max-h-48 mx-auto mb-4" />
      <p>
        Sharing
        <span class="font-bold">{{ titleList?.attributes.title }}</span
        >.
      </p>
      <div class="flex gap-2 mt-4 items-center">
        <NamiButton
          v-for="shareLocation in shareLocations"
          :icon="shareLocation.icon"
          target="_blank"
          button-type="secondary"
          text
          :href="shareLocation.url"
        />
        <NamiButton
          class="ml-auto"
          pill
          button-type="secondary"
          :icon="IconCopy"
          small
          :title="currentUrl"
          @button-click="tryCopyLink"
        >
          <div class="pr-1">
            {{ currentUrl.slice(0, 32)
            }}{{ currentUrl.length > 32 ? "..." : "" }}
          </div>
        </NamiButton>
      </div>
    </div>
  </NamiModal>
</template>

<script setup lang="ts">
import {
  IconBrandFacebook,
  IconBrandReddit,
  IconBrandTwitter,
  IconCopy,
  IconLink,
} from "@tabler/icons-vue";
import { isTitle, type TitleListEntity } from "~/src/api";

const config = useRuntimeConfig();
const oauth = useLoggedOAuthUserData();

const open = defineModel<boolean>("modelValue", { required: true });
const props = defineProps<{
  titleList: TitleListEntity;
}>();

const creator = computed(() => props.titleList.relationships.find(isTitle));

const redditShareUrl = computed(() => {
  const url = new URL("https://www.reddit.com/submit");

  url.searchParams.set("url", config.public.baseUrl + linkTo(props.titleList));

  // let title = `Check out this list {that I made}: `
  let title = "Check out this list";
  if (creator.value && creator.value.id === oauth.value?.profile.sub)
    title += "that I made";
  title += ": ";

  url.searchParams.set("title", title);
  return url.href;
});

const twitterShareUrl = computed(() => {
  const url = new URL("https://twitter.com/intent/tweet");

  let text = "Check out this list";
  if (creator.value && creator.value.id === oauth.value?.profile.sub)
    text += "that I made";
  text += `: ${config.public.baseUrl + linkTo(props.titleList)}\n\n`;
  text += "#NamiComi";

  url.searchParams.set("text", text);
  return url.href;
});

const currentUrl = computed(() => `https://nami.moe/l/${props.titleList.id}`);
const tryCopyLink = () => {
  copyTextToClipboard(currentUrl.value);
  open.value = false;
};

const shareLocations = computed(() => [
  {
    name: "Facebook",
    url: `https://www.facebook.com/sharer/sharer.php?u=${
      config.public.baseUrl + linkTo(props.titleList)
    }`,
    icon: IconBrandFacebook,
  },
  {
    name: "Reddit",
    url: redditShareUrl.value,
    icon: IconBrandReddit,
  },
  {
    name: "Twitter",
    url: twitterShareUrl.value,
    icon: IconBrandTwitter,
  },
]);
</script>
